module.exports = __webpack_public_path__ + "img/ltkeaster-3x.6e51dff.jpg";